import { apiClient } from '@/lib/api/client';

export async function getFeaturedParts(limit = 40) {
    return apiClient.get('/part/featured', { params: { limit } });
}

export async function getPartList(params = {}) {
    return apiClient.get('/part/list', { params });
}

export async function getCategoryList(type = 'part') {
    return apiClient.get('/category/list', { params: { type } });
}

export async function getPartDetail(id) {
    return apiClient.get(`/part/${id}`);
}

export const partsApi = {
    featured: getFeaturedParts,
    list: getPartList,
    categoryList: getCategoryList,
    detail: getPartDetail,
};
export default partsApi;